import { useState, useEffect } from 'react';
import Select from 'react-select';
const cx = require('classnames');

const MultiSelectContainer = (props) => {
    const options = props.options || [];
    const [selectedValues, setSelectedValues] = useState([]);
    const onChange = props.onChange || (() => {});
    const errormsg = props.error || false;
    const label = props.label || '';
    const id = props.id || 'id_select_'+label.replace(/[^A-Za-z0-9-_]/g, '');

    useEffect(() => {
        if (props.value) {
            const values = Array.isArray(props.value) ? props.value : [props.value];
            // Map the value keys to their corresponding option objects
            const selectedOptions = values.map(value => 
                options.find(option => option.value === value)
            ).filter(Boolean);
            setSelectedValues(selectedOptions);
        }
    }, [props.value, options]);

    const handleChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setSelectedValues(selectedOptions || []);
        onChange(props.id, values);
    };

    return (
        <div className={ cx('form-group', { 'has-error': !!errormsg }) }>
            <label className={ cx('control-label') } htmlFor={ id }>{ label }</label>
            <div className={ cx('') }>
                <Select
                    options={options}
                    value={selectedValues}
                    onChange={handleChange}
                    isMulti={true}
                />
            </div>
        </div>
    );
};

export default MultiSelectContainer;